class TempTicker extends HTMLElement {
	constructor() {
		super();
		this.cityJson = JSON.parse(this.querySelector('[data-city-json]').innerHTML);
		this.cityJson.forEach((city) => this.fetchTemp(city));
	}

	createCityEl(name, temp) {
		let cityItem = document.createElement('p')
		let itemContent = document.createTextNode(name + ' ' + temp + '°')

		cityItem.appendChild(itemContent)
		return cityItem
	}

	fetchTemp(city) {
		const API_KEY = '7f46449027e8d930fcda9eaf6e7f0df6'

		fetch(`https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${API_KEY}`)

		.then(response =>  {
			return response.json()
		})
		.then(json => {
			const name = json.name
			const main = json.main
			const kelvin = main.temp
			const temp = ((kelvin - 273.15) * 9/5 + 32).toFixed(0)

			let newCity = this.createCityEl(name, temp)
			this.appendChild(newCity)
		})
		.catch(error => {
			console.log(error)
		})
	}

}
window.customElements.define('temp-ticker', TempTicker);
